<template>
	<ul class="menu">
		<li :class="{'act':menuCheckedItem == index}" v-for="(item,index) in Menulist.MenuList" :key="index" @click="changeNavIndex(item.id,item.value,item.route,index)">
			{{item.name}}
		</li>
	</ul>
</template>

<script>
	export default {
		props: ["Menulist", "checkedValue"],
		data(){
			return{
				menuCheckedItem:0
			}
		},	
		methods: {
			changeNavIndex(num, v, r,i) {	
				
				this.menuCheckedItem = i;
				this.$router.push(r);
				//调取父级的方法
				this.$emit('changeNavIndex', num, v)
			}
		},
		mounted(){
			console.log(this)
		}
	};
</script>

<style lang="scss">
	.menu {
		flex: 0 0 200px;
		list-style: none;
		padding: 20px 0 0 0;
		margin: 0;

		@media screen and (max-width: 768px) {
			display: flex;
			justify-content: space-between;
		}

		li {
			height: 50px;
			border-bottom: 1px solid #d8d8d8;
			padding: 8% 34px;
			cursor: pointer;
			white-space: nowrap;

			@media screen and (max-width: 768px) {
				flex: 0 0 91px;
				padding: 0;
				text-align: center;
				line-height: 43px;
				height: 43px;
				overflow: hidden;
				border: 1px solid #d8d8d8;
			}
		}

		li a {
			color: #000000;
		}

		li:hover {
			color: #d0a971;
		}

		li.act {
			color: #d0a971;
		}

		li:hover::before {
			@media screen and (max-width: 768px) {
				background: #d0a971;
				width: 4px;
				height: 20px;
				position: absolute;
				left: 0;
				content: "";
				height: 42px;
			}
		}

		li.act::before {
			background: #d0a971;
			width: 4px;
			height: 20px;
			position: absolute;
			left: 0;
			content: "";
		}
	}
</style>
